"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _server = _interopRequireDefault(require("react-dom/server"));
var _cccisdPaginator = _interopRequireDefault(require("cccisd-paginator"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _forIn2 = _interopRequireDefault(require("lodash/forIn"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _escapeRegExp2 = _interopRequireDefault(require("lodash/escapeRegExp"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _slice2 = _interopRequireDefault(require("lodash/slice"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _memoize2 = _interopRequireDefault(require("lodash/memoize"));
var _cccisdSpinner = _interopRequireDefault(require("cccisd-spinner"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _md = _interopRequireDefault(require("md5"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _actions = _interopRequireDefault(require("./actions.js"));
var _filter3 = _interopRequireDefault(require("./filter.js"));
var _filterSelected = _interopRequireDefault(require("./filterSelected.js"));
var _disabledMessage = _interopRequireDefault(require("./disabledMessage.js"));
var _listTemplate = _interopRequireDefault(require("./listTemplate.js"));
var _store = _interopRequireDefault(require("store"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/svg/arrow-up20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/svg/arrow-down20"));
var _checkboxChecked = _interopRequireDefault(require("cccisd-icons/checkbox-checked"));
var _checkboxUnchecked = _interopRequireDefault(require("cccisd-icons/checkbox-unchecked"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross4"));
var _loop = _interopRequireDefault(require("cccisd-icons/loop3"));
var _download = _interopRequireDefault(require("cccisd-icons/download"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _table = _interopRequireDefault(require("./table.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** cccisd-table provides you with a table React component. It can be sortable and filterable. You can download data as an CSV file. */
var Table = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Table(_props, context) {
    var _this;
    _classCallCheck(this, Table);
    _this = _callSuper(this, Table, [_props, context]);
    // Component properties
    _defineProperty(_this, "filteredTotal", 0);
    _defineProperty(_this, "_isAjaxMode", function () {
      return _this.props.apiUrl !== '';
    });
    _defineProperty(_this, "_isAjax", function () {
      return _this._isAjaxMode() && _this.props.ajaxLimit !== 0 && _this.props.ajaxLimit <= _this.state.filtered;
    });
    _defineProperty(_this, "_isAllData", function () {
      return !_this._isAjaxMode() || _this.state.total <= _this.props.ajaxLimit;
    });
    _defineProperty(_this, "_isTopHeader", function () {
      return (0, _memoize2["default"])(function (columns) {
        return columns.some(function (column) {
          return column.topHeader;
        });
      })(_this.props.columns);
    });
    _defineProperty(_this, "_getQuery", function () {
      var query = [];
      if (!(0, _isEmpty2["default"])(_this.props.constantFilter) && !(0, _isFunction2["default"])(_this.props.constantFilter)) {
        (0, _forIn2["default"])(_this.props.constantFilter, function (value, key) {
          query.push("*".concat(key, "=").concat(value));
        });
      }

      // Set ajax row number
      query.push('_ajax=' + _this.props.ajaxLimit);

      // Set limit
      query.push('_limit=' + _this.state.perPage);

      // Set offset
      query.push('_offset=' + _this._getStartRowNumber());

      // Set filter
      _this.props.columns.forEach(function (column, index) {
        if (!column.ajax || !(0, _has2["default"])(column, 'filter') || column.filter !== true || !(0, _has2["default"])(_this.state.filters, column.name)) {
          return;
        }
        var filterSettings = column.filterSettings || {
          type: 'text'
        };
        var field = filterSettings.field || column.name;
        if (_typeof(field) === 'object') {
          console.warn("You cannot use field as an array for column \"".concat(column.name, "\""));
          return;
        }
        switch (filterSettings.type) {
          case 'text':
            query.push(field + '-lk=*' + encodeURIComponent(_this.state.filters[column.name]) + '*');
            break;
          case 'equal':
            query.push(field + '=' + encodeURIComponent(_this.state.filters[column.name]));
            break;
          case 'selectbox':
            if ((0, _has2["default"])(filterSettings, 'custom')) {
              console.warn("You cannot use custom function for column \"".concat(column.name, "\""));
            }
            query.push(field + '=' + encodeURIComponent(_this.state.filters[column.name]));
            break;
          case 'date':
            {
              var _this$state$filters$c = _slicedToArray(_this.state.filters[column.name], 2),
                startDate = _this$state$filters$c[0],
                endDate = _this$state$filters$c[1];
              if (startDate) {
                query.push(field + '-min=' + startDate + ' 00:00:00');
              }
              if (endDate) {
                query.push(field + '-max=' + endDate + ' 23:59:59');
              }
              break;
            }
          default:
            console.warn("Unknown filter type \"".concat(filterSettings.type, "\""));
            break;
        }
      });

      // Set order
      var currentColumn = (0, _find2["default"])(_this.props.columns, {
        name: _this.state.orderBy
      });
      if (currentColumn && currentColumn.ajax) {
        var order = _this.state.isAscentOrder ? '' : '-';
        query.push('_sort=' + order + _this.state.orderBy);
      }
      (0, _forEach2["default"])(_this.props.constantQuery, function (value, key) {
        query.push(key + '=' + value);
      });
      return '?' + query.join('&');
    });
    _defineProperty(_this, "_update", function () {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var hardLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.isHardLoading;
      var $this = _this;
      $this.setState({
        loading: loading,
        hardLoading: hardLoading
      });
      return new Promise(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
          var response;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _cccisdAxios["default"].get(_this.props.apiUrl + _this._getQuery());
              case 2:
                response = _context.sent;
                $this.setState({
                  data: response.data.data,
                  total: response.data.total || response.data.data.length,
                  filtered: response.data.filtered || 0,
                  loading: false,
                  selectedRows: []
                }, function () {
                  resolve();
                });
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    });
    _defineProperty(_this, "_planUpdate", function () {
      // Don't update if it is not ajax mode
      if (!_this._isAjaxMode()) {
        return;
      }
      if (_this.timeout) {
        clearTimeout(_this.timeout);
      }
      _this.setState({
        loading: true,
        hardLoading: false
      });
      _this.timeout = setTimeout(function () {
        _this._update(true, false);
      }, 500);
    });
    // Return data with applied constantFilter
    _defineProperty(_this, "_getActualData", function () {
      if (_this._isAjaxMode()) {
        return _this.state.data;
      }
      if ((0, _isEmpty2["default"])(_this.props.constantFilter) && !(0, _isFunction2["default"])(_this.props.constantFilter)) {
        return _this.props.data;
      }
      return (0, _filter2["default"])(_this.props.data, _this.props.constantFilter);
    });
    // Return only selected rows which matches the data
    _defineProperty(_this, "_getRealSelectedRows", function () {
      var allRows = (0, _map2["default"])(_this._getActualData(), _this.props.rowKey).map(function (id) {
        return id.toString();
      });
      return (0, _intersection2["default"])(_this.state.selectedRows, allRows);
    });
    _defineProperty(_this, "_gotoPage", function (page) {
      _this.setState({
        currentPage: page
      }, function () {
        if (_this._isAjax()) {
          _this._update();
        }
      });
    });
    _defineProperty(_this, "_getHash", function () {
      // Generate unique hash for the page+table
      var str = _this.props.useOnlyNameForHash ? _this.props.name : window.location.hostname + window.location.pathname + (0, _map2["default"])(_this.props.columns, 'name').toString() + _this.props.name;
      return (0, _md["default"])(str).substr(0, 10);
    });
    _defineProperty(_this, "_saveSettings", function () {
      if (!_this.props.saveState) {
        return;
      }
      var hash = _this._getHash();
      var state = _store["default"].get('cccisd-table');
      var oldSettings = state && state[hash];
      var newSettings = {
        filters: _this.state.filters,
        orderBy: _this.state.orderBy,
        isAscentOrder: _this.state.isAscentOrder,
        perPage: _this.state.perPage
      };
      if (!(0, _isEqual2["default"])(oldSettings, newSettings)) {
        _store["default"].set('cccisd-table', _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, hash, newSettings)));
      }
    });
    _defineProperty(_this, "_getSettings", function () {
      var state = _store["default"].get('cccisd-table');
      var settings = state && state[_this._getHash()];
      if (!settings) {
        settings = {
          filters: {},
          orderBy: _this.props.orderBy,
          isAscentOrder: _this.props.isAscentOrder,
          perPage: _this.props.perPage
        };
      }

      // Use props filter if exists
      if (!(0, _isEmpty2["default"])(_this.props.filter)) {
        settings.filters = _this.props.filter;
      }

      // Check if orderBy is correct
      var column = (0, _find2["default"])(_this.props.columns, {
        name: settings.orderBy,
        sort: true
      });
      if (column === undefined) {
        column = (0, _find2["default"])(_this.props.columns, ['sort', true]);
      }
      settings.orderBy = column === undefined ? '' : column.name;

      // Check if isAscentOrder is boolean
      if (typeof settings.isAscentOrder !== 'boolean') {
        settings.isAscentOrder = true;
      }

      // Check if perPage is in range
      if (_this.props.perPageOptions.indexOf(settings.perPage) === -1) {
        settings.perPage = _this.props.perPage;
      }
      return settings;
    });
    _defineProperty(_this, "_onPerPageChange", function (event) {
      _this.setState({
        perPage: event.target.value * 1,
        currentPage: 1
      }, function () {
        if (!_this._isAllData()) {
          _this._update();
        }
      });
    });
    _defineProperty(_this, "_onFilterChange", function (column, value) {
      var filters = _this.state.filters;
      if (value === '') {
        delete filters[column];
      } else {
        filters[column] = value;
      }
      _this.setState({
        currentPage: 1,
        filters: filters
      }, function () {
        if (!_this._isAllData()) {
          var currentColumn = (0, _find2["default"])(_this.props.columns, ['name', column]);
          if (currentColumn.ajax) {
            _this._planUpdate();
          }
        }
      });
    });
    _defineProperty(_this, "_removeFilter", function () {
      _this.setState({
        currentPage: 1,
        showOnlySelected: false,
        filters: {}
      }, function () {
        if (!_this._isAllData()) {
          _this._update();
        }
      });
    });
    _defineProperty(_this, "_onSelectRow", function (event) {
      var value = event.target.value;
      var selectedRows = _this.state.selectedRows;
      var index = selectedRows.indexOf(value);
      if (index === -1) {
        selectedRows.push(value);
      } else {
        selectedRows.splice(index, 1);
      }
      _this.setState({
        selectedRows: selectedRows
      });
    });
    _defineProperty(_this, "_onSelectAll", function (e) {
      e.preventDefault();
      if (_this._isAjax()) {
        return;
      }
      var selectedRows = _this.state.selectedRows;
      var rows = _this._getFilteredData();
      rows.forEach(function (row) {
        if (selectedRows.indexOf(row[_this.props.rowKey].toString()) === -1) {
          selectedRows.push(row[_this.props.rowKey].toString());
        }
      });
      _this.setState({
        selectedRows: selectedRows
      });
    });
    _defineProperty(_this, "_onSelectReallyAll", function (e) {
      var checked = e.target.checked;
      var selectedRows = [];
      if (checked) {
        selectedRows = _this._getActualData().map(function (row) {
          return row[_this.props.rowKey].toString();
        });
      }
      _this.setState({
        selectAllChecked: checked,
        selectedRows: selectedRows
      });
    });
    _defineProperty(_this, "_onSelectNone", function (e) {
      e.preventDefault();
      if (_this._isAjax()) {
        return;
      }
      var selectedRows = _this.state.selectedRows;
      var rows = _this._getFilteredData();
      rows.forEach(function (row) {
        var index = selectedRows.indexOf(row[_this.props.rowKey].toString());
        if (index !== -1) {
          selectedRows.splice(index, 1);
        }
      });
      _this.setState({
        selectedRows: selectedRows
      });
    });
    _defineProperty(_this, "_afterAction", function () {
      _this.setState({
        showOnlySelected: false,
        selectedRows: []
      });
    });
    _defineProperty(_this, "_onOrder", function (orderBy, order) {
      var isAscentOrder;
      if ((0, _isString2["default"])(order)) {
        isAscentOrder = order.toLowerCase() === 'asc';
      } else {
        isAscentOrder = _this.state.isAscentOrder;
        // eslint-disable-next-line eqeqeq
        if (_this.state.orderBy == orderBy) {
          isAscentOrder = !isAscentOrder;
        }
      }
      _this.setState({
        currentPage: 1,
        orderBy: orderBy,
        isAscentOrder: isAscentOrder
      }, function () {
        if (_this._isAjax()) {
          _this._update();
        }
      });
    });
    _defineProperty(_this, "_registerFilterFunction", function (func) {
      _this.setState({
        filterFunction: func
      });
    });
    _defineProperty(_this, "_getFilteredData", function () {
      var rows = _this._getActualData();

      // Don't proceed if it is an ajax request
      if (_this._isAjax()) {
        return rows;
      }
      if ((0, _isFunction2["default"])(_this.state.filterFunction)) {
        rows = (0, _filter2["default"])(rows, _this.state.filterFunction);
      }
      if (_this.state.showOnlySelected) {
        rows = (0, _filter2["default"])(rows, function (row) {
          return _this.state.selectedRows.indexOf(row[_this.props.rowKey].toString()) !== -1;
        });
      }

      // Apply the filter
      _this.props.columns.forEach(function (column, index) {
        if (_this._isAjaxMode() && !_this._isAllData() && column.ajax || !(0, _has2["default"])(column, 'filter') || column.filter !== true || !(0, _has2["default"])(_this.state.filters, column.name)) {
          return;
        }
        var filterSettings = column.filterSettings || {
          type: 'text'
        };
        var fields = filterSettings.field || column.name;
        // make fields array
        if (typeof fields === 'string') {
          fields = [fields];
        }
        if ((0, _has2["default"])(filterSettings, 'custom')) {
          rows = (0, _filter2["default"])(rows, function (row) {
            return filterSettings.custom(row, _this.state.filters[column.name]);
          });
        } else {
          switch (filterSettings.type) {
            case 'text':
              {
                rows = (0, _filter2["default"])(rows, function (row) {
                  var result = false;
                  fields.forEach(function (field) {
                    if (_this.state.filters[column.name] === _this.props.emptySymbol) {
                      // Check if the column is empty
                      if (String(row[field]) === '' || row[field] === null) {
                        result = true;
                      }
                    } else if (String(row[field]).match(new RegExp((0, _escapeRegExp2["default"])(_this.state.filters[column.name]), 'i'))) {
                      result = true;
                    }
                  });
                  return result;
                });
                break;
              }
            case 'equal':
              {
                rows = (0, _filter2["default"])(rows, function (row) {
                  var result = false;
                  fields.forEach(function (field) {
                    // eslint-disable-next-line eqeqeq
                    if (row[field] == _this.state.filters[column.name]) {
                      result = true;
                    }
                  });
                  return result;
                });
                break;
              }
            case 'selectbox':
              {
                rows = (0, _filter2["default"])(rows, function (row) {
                  var result = false;
                  fields.forEach(function (field) {
                    // eslint-disable-next-line eqeqeq
                    if (row[field] == _this.state.filters[column.name]) {
                      result = true;
                    }
                  });
                  return result;
                });
                break;
              }
            case 'date':
              {
                var _this$state$filters$c2 = _slicedToArray(_this.state.filters[column.name], 2),
                  startDate = _this$state$filters$c2[0],
                  endDate = _this$state$filters$c2[1];
                if (startDate) {
                  startDate += ' 00:00:00';
                  rows = (0, _filter2["default"])(rows, function (row) {
                    var result = false;
                    fields.forEach(function (field) {
                      if (row[field] >= startDate) {
                        result = true;
                      }
                    });
                    return result;
                  });
                }
                if (endDate) {
                  endDate += ' 23:59:59';
                  rows = (0, _filter2["default"])(rows, function (row) {
                    var result = false;
                    fields.forEach(function (field) {
                      if (row[field] <= endDate) {
                        result = true;
                      }
                    });
                    return result;
                  });
                }
                break;
              }
            default:
              {
                console.warn("There is no \"".concat(filterSettings.type, "\" filter type"));
                break;
              }
          }
        }
      });

      // Order the data
      if (_this.state.orderBy !== '') {
        var column = (0, _find2["default"])(_this.props.columns, ['name', _this.state.orderBy]);

        // Check if the column hasn't been removed
        if (column !== undefined) {
          var sortSettings = column.sortSettings || {};
          if ((0, _isFunction2["default"])(sortSettings.custom)) {
            rows = (0, _sortBy2["default"])(rows, sortSettings.custom);
          } else {
            var orderBy = sortSettings.field || column.name;
            rows = (0, _sortBy2["default"])(rows, orderBy);
          }
          if (!_this.state.isAscentOrder) {
            rows.reverse();
          }
        }
      }
      return rows;
    });
    _defineProperty(_this, "_toggleShowOnlySelected", function () {
      _this.setState({
        currentPage: 1,
        showOnlySelected: !_this.state.showOnlySelected
      });
    });
    _defineProperty(_this, "_getColumnsForCsv", function () {
      return (0, _filter2["default"])(_this.props.columns, function (column) {
        return !_this.props.csvOmittedColumns.includes(column.name);
      });
    });
    _defineProperty(_this, "_defaultDownloadCsv", function (rows) {
      // For now we just remove quotes inside and wrap it in quotes
      var prepare = function prepare(string) {
        // strip HTML tags
        // ignore emails like this <some@gmail.com>
        string = string.replace(/(<([^>@]+)>)/gi, '');
        return '"' + string.replace(/"/, '') + '"';
      };
      var columns = _this._getColumnsForCsv();

      // Compose csv
      var csv = [];

      // Add column names
      csv.push(columns.map(function (column) {
        var label = /*#__PURE__*/_react["default"].isValidElement(column.label) ? _server["default"].renderToStaticMarkup(column.label) : column.label;
        return prepare(label);
      }).join(','));

      // Add data
      rows.forEach(function (row) {
        var array = columns.map(function (column) {
          var value;
          if ((0, _isFunction2["default"])(column.renderCSV)) {
            value = column.renderCSV(row[column.name], row);
          } else {
            value = (0, _isFunction2["default"])(column.render) ? column.render(row[column.name], row, _this.props.callbacks) : row[column.name];
          }
          if (typeof value === 'undefined') {
            value = '';
          }
          value = /*#__PURE__*/_react["default"].isValidElement(value) ? _server["default"].renderToStaticMarkup(value) : String(value);
          return prepare(value);
        });
        csv.push(array.join(','));
      });
      csv = csv.join('\n');
      var blob = new Blob([csv], {
        type: 'text/csv'
      });
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = _this.props.csvFilename;
      link.click();
    });
    _defineProperty(_this, "_downloadCsv", function () {
      var rows = _this._getFilteredData();
      if (_this.props.csvDownloadFunction) {
        _this.props.csvDownloadFunction(rows, _this._getQuery());
      } else {
        _this._defaultDownloadCsv(rows);
      }
    });
    _defineProperty(_this, "_renderButtons", function () {
      var buttons = [];

      // Reload data button
      var reloadDataButton = _this._renderReloadDataButton();
      if (reloadDataButton) {
        buttons.push(reloadDataButton);
      }

      // Per page
      var perPageOptions = _this._renderPerPageOptions();
      if (perPageOptions) {
        buttons.push(perPageOptions);
      }

      // CSV download button
      if (_this.props.isCsvDownload) {
        buttons.push(/*#__PURE__*/_react["default"].createElement("span", {
          className: _table["default"].button,
          key: "csvDownload"
        }, /*#__PURE__*/_react["default"].createElement(_disabledMessage["default"], {
          number: _this.props.ajaxLimit,
          disabled: typeof _this.props.csvDownloadFunction !== 'function' && _this._isAjax()
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-secondary btn-sm",
          onClick: _this._downloadCsv,
          title: "Download as CSV",
          disabled: typeof _this.props.csvDownloadFunction !== 'function' && _this._isAjax()
        }, /*#__PURE__*/_react["default"].createElement(_download["default"], {
          spaceRight: true
        }), _this.props.csvButtonTitle))));
      }
      if (buttons.length === 0) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _table["default"].buttons
      }, buttons);
    });
    _defineProperty(_this, "_renderPerPageOptions", function () {
      if (!_this.props.showPerPageOptions) {
        return null;
      }
      var options = _this.props.perPageOptions.map(function (number) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: number,
          value: number
        }, number);
      });
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _table["default"].button,
        key: "perPage"
      }, "Per page:", ' ', /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-select form-select-sm",
        style: {
          width: 'auto',
          display: 'inline-block'
        },
        value: _this.state.perPage,
        onChange: _this._onPerPageChange
      }, options));
    });
    _defineProperty(_this, "_renderReloadDataButton", function () {
      if (!_this._isAjaxMode() || !_this.props.showReloadButton) {
        return null;
      }
      var spinner = _this.state.loading && !_this.state.hardLoading ? /*#__PURE__*/_react["default"].createElement(_cccisdSpinner["default"], null) : null;
      var buttonStyle = _this.state.loading && !_this.state.hardLoading ? {
        visibility: 'hidden'
      } : {};
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _table["default"].button,
        key: "refresh",
        style: {
          position: 'relative',
          display: 'inline-block'
        }
      }, spinner, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-secondary btn-sm",
        onClick: _this._update.bind(null, true, true),
        title: "Reload data",
        style: buttonStyle
      }, /*#__PURE__*/_react["default"].createElement(_loop["default"], null)));
    });
    _defineProperty(_this, "_getTotal", function () {
      return _this._isAjaxMode() ? _this.state.total : _this._getActualData().length;
    });
    _defineProperty(_this, "_getFilteredTotal", function () {
      return _this._isAjax() ? _this.state.filtered : _this.filteredTotal;
    });
    _defineProperty(_this, "_renderCount", function (filtered, all) {
      var clearFilter = null;
      if (_this.state.showOnlySelected || !(0, _isEmpty2["default"])(_this.state.filters)) {
        clearFilter = /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-primary btn-xs",
          onClick: _this._removeFilter
        }, /*#__PURE__*/_react["default"].createElement(_cross["default"], {
          spaceRight: true
        }), "Remove Filter");
      }
      var countMsg = _this.props.hideShowingRowsSummary ? null : /*#__PURE__*/_react["default"].createElement("span", null, "Showing ", filtered, " of ", all, " rows");
      if (!countMsg && !clearFilter) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _table["default"].countBlock
      }, countMsg, clearFilter);
    });
    _defineProperty(_this, "_renderThead", function () {
      var getColumn = function getColumn(column) {
        var isRowSpan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var className = column["class"] || '';
        var tooltip;
        if (column.tooltip) {
          tooltip = /*#__PURE__*/_react["default"].createElement("span", {
            className: _table["default"].tooltip
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                textAlign: 'left'
              }
            }, column.tooltip)
          }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)));
        }

        // Show sort style
        if (column.sort && (column.ajax || !_this._isAjax())) {
          className += ' ' + _table["default"].sortable;
          // eslint-disable-next-line eqeqeq
          if (column.name == _this.state.orderBy) {
            className += _this.state.isAscentOrder ? ' ' + _table["default"].sortable_asc : ' ' + _table["default"].sortable_desc;
          }
          return /*#__PURE__*/_react["default"].createElement("th", _extends({
            className: className,
            key: column.name,
            onClick: _this._onOrder.bind(null, column.name)
          }, isRowSpan ? {
            rowSpan: 2
          } : {}), /*#__PURE__*/_react["default"].createElement("div", {
            className: _table["default"].up
          }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
            className: _table["default"].down
          }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)), column.label, tooltip);
        }
        return /*#__PURE__*/_react["default"].createElement("th", _extends({
          className: className,
          key: column.name
        }, isRowSpan ? {
          rowSpan: 2
        } : {}), column.label, tooltip);
      };
      var isTopHeader = _this._isTopHeader();
      var columns = _this.props.columns;
      if (isTopHeader) {
        var spanCount = 0;
        var colSpan = 0;
        columns.forEach(function (column, index) {
          if (column.topHeader) {
            if (spanCount > 0) {
              columns[index - colSpan + spanCount].colSpan = colSpan - spanCount;
            }
            colSpan = column.topHeaderSpan || 1;
            column.colSpan = colSpan;
            spanCount = colSpan;
          }
          if (spanCount-- < 1) {
            column.isRowSpan = true;
          }
        });
        if (spanCount > 0) {
          columns[columns.length - colSpan + spanCount].colSpan = colSpan - spanCount;
        }
      }
      var firstRow = [];
      var secondRow = [];
      columns.forEach(function (column) {
        if (column.topHeader) {
          firstRow.push(/*#__PURE__*/_react["default"].createElement("th", {
            key: column.name,
            colSpan: column.colSpan,
            className: _table["default"].topHeader
          }, column.topHeader, column.topHeaderTooltip && /*#__PURE__*/_react["default"].createElement("span", {
            className: _table["default"].tooltip
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                textAlign: 'left'
              }
            }, column.topHeaderTooltip)
          }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))));
        }
        if (column.isRowSpan || !isTopHeader) {
          firstRow.push(getColumn(column, column.isRowSpan));
        } else {
          secondRow.push(getColumn(column));
        }
      });

      // Is Number?
      if (_this.props.isRowNumber) {
        firstRow.unshift(/*#__PURE__*/_react["default"].createElement("th", _extends({
          key: "number_column",
          className: _table["default"].numberColumn
        }, secondRow.length > 0 ? {
          rowSpan: 2
        } : {}), "#"));
      }

      // Is Checkbox?
      if (_this._isShowCheckboxes()) {
        if (_this.props.isSimpleCheckboxes) {
          var title = _this.state.selectAllChecked ? 'Uncheck all' : 'Check all';
          firstRow.unshift(/*#__PURE__*/_react["default"].createElement("th", _extends({
            key: "checkbox_column",
            className: _table["default"].checkboxColumn + ' ' + _table["default"].checkboxColumnSimple
          }, secondRow.length > 0 ? {
            rowSpan: 2
          } : {}), /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            title: title,
            type: "checkbox",
            value: "1",
            checked: _this.state.selectAllChecked,
            onChange: _this._onSelectReallyAll,
            disabled: _this._isAjax()
          }))));
        } else {
          firstRow.unshift(/*#__PURE__*/_react["default"].createElement("th", _extends({
            key: "checkbox_column",
            className: _table["default"].checkboxColumn
          }, secondRow.length > 0 ? {
            rowSpan: 2
          } : {}), /*#__PURE__*/_react["default"].createElement("a", {
            href: "#",
            onClick: _this._onSelectAll,
            title: "Check all filtered records"
          }, /*#__PURE__*/_react["default"].createElement(_checkboxChecked["default"], null)), ' ', /*#__PURE__*/_react["default"].createElement("a", {
            href: "#",
            onClick: _this._onSelectNone,
            title: "Uncheck all filtered records"
          }, /*#__PURE__*/_react["default"].createElement(_checkboxUnchecked["default"], null))));
        }
      }
      var result = [/*#__PURE__*/_react["default"].createElement("tr", {
        key: "first"
      }, firstRow)];
      if (secondRow.length > 0) {
        result.push(/*#__PURE__*/_react["default"].createElement("tr", {
          key: "second"
        }, secondRow));
      }
      return result;
    });
    _defineProperty(_this, "_renderTfoot", function () {
      if (!_this.props.footer) {
        return null;
      }
      var foot = _this.props.columns.map(function (column) {
        return /*#__PURE__*/_react["default"].createElement("th", null, _this.props.footer[column.name]);
      });
      if (_this.props.isRowNumber) {
        foot.unshift(/*#__PURE__*/_react["default"].createElement("th", {
          className: _table["default"].numberColumn
        }));
      }
      if (_this._isShowCheckboxes()) {
        foot.unshift(/*#__PURE__*/_react["default"].createElement("th", {
          className: _table["default"].checkboxColumn
        }));
      }
      return /*#__PURE__*/_react["default"].createElement("tfoot", null, /*#__PURE__*/_react["default"].createElement("tr", null, foot));
    });
    _defineProperty(_this, "_isShowCheckboxes", function () {
      return _this.props.rowActions.length > 0 || (0, _isFunction2["default"])(_this.props.rowSelectedCallback);
    });
    _defineProperty(_this, "_onRowClick", function (row) {
      _this.props.onRowClick(row);
    });
    _defineProperty(_this, "_renderFilter", function () {
      // Don't show filter if there is no data
      if (_this._getTotal() === 0) {
        return null;
      }
      if (!(0, _find2["default"])(_this.props.columns, {
        filter: true
      }) && !_this._isShowCheckboxes()) {
        return null;
      }
      var lastColumn = (0, _last2["default"])(_this.props.columns);
      var filters = _this.props.columns.map(function (column) {
        var className = column["class"] || '';
        if ((0, _has2["default"])(column, 'filter') && column.filter === true) {
          var disabled = _this._isAjax() && !column.ajax;
          return /*#__PURE__*/_react["default"].createElement("th", {
            key: column.name,
            className: className
          }, /*#__PURE__*/_react["default"].createElement(_disabledMessage["default"], {
            number: _this.props.ajaxLimit,
            disabled: disabled,
            display: "block",
            placement: column.name === lastColumn.name ? 'bottom-left' : 'bottom'
          }, /*#__PURE__*/_react["default"].createElement(_filter3["default"], {
            column: column.name,
            value: _this.state.filters[column.name],
            onFilterChange: _this._onFilterChange,
            settings: column.filterSettings,
            disabled: disabled
          })));
        }
        return /*#__PURE__*/_react["default"].createElement("th", {
          key: column.name,
          className: className
        });
      });

      // Is Number?
      if (_this.props.isRowNumber) {
        filters.unshift(/*#__PURE__*/_react["default"].createElement("th", {
          key: "number_column"
        }));
      }
      // Is Checkbox?
      if (_this._isShowCheckboxes()) {
        if (_this.props.isSimpleCheckboxes) {
          filters.unshift(/*#__PURE__*/_react["default"].createElement("th", {
            key: "checkbox_column"
          }));
        } else {
          filters.unshift(/*#__PURE__*/_react["default"].createElement("th", {
            key: "checkbox_column"
          }, /*#__PURE__*/_react["default"].createElement(_disabledMessage["default"], {
            number: _this.props.ajaxLimit,
            disabled: _this._isAjax(),
            placement: "right",
            size: null
          }, /*#__PURE__*/_react["default"].createElement(_filterSelected["default"], {
            showSelected: _this.state.showOnlySelected,
            onClick: _this._toggleShowOnlySelected,
            disabled: _this._isAjax()
          }))));
        }
      }
      return /*#__PURE__*/_react["default"].createElement("tr", null, filters);
    });
    _defineProperty(_this, "_getStartRowNumber", function () {
      return (_this.state.currentPage - 1) * _this.state.perPage;
    });
    _defineProperty(_this, "_getRowsForPage", function () {
      var rows = _this._getFilteredData();
      _this.filteredTotal = rows.length;

      // Get rows for current page
      var start = _this._getStartRowNumber();
      if (!_this._isAjax()) {
        var end = _this.state.currentPage * _this.state.perPage;
        rows = (0, _slice2["default"])(rows, start, end);
      }
      return rows;
    });
    _defineProperty(_this, "_renderTbody", function () {
      var rows = _this._getRowsForPage();
      var start = _this._getStartRowNumber();

      // Render column values
      rows = rows.map(function (item, index) {
        var key = item[_this.props.rowKey].toString();
        var row = _this.props.columns.map(function (column) {
          var value = (0, _isFunction2["default"])(column.render) ? column.render(item[column.name], item, _this.props.callbacks) : item[column.name];
          var className = column["class"] || '';

          // Add special classes
          if ((0, _isFunction2["default"])(column.setClass)) {
            className += ' ' + column.setClass(item[column.name], item);
          }

          // Add special style
          var tdStyle = {};
          if ((0, _isFunction2["default"])(column.setStyle)) {
            tdStyle = column.setStyle(item[column.name], item);

            // Remove backgroundColor and color for selected rows
            if (_this.state.selectedRows.indexOf(key) !== -1) {
              delete tdStyle.backgroundColor;
              delete tdStyle.color;
            }
          }
          var props = {
            className: className,
            key: column.name,
            style: tdStyle
          };
          if (_this.props.onRowClick) {
            props.onClick = _this._onRowClick.bind(null, item);
          }
          return /*#__PURE__*/_react["default"].createElement("td", props, value);
        });

        // Is Number?
        if (_this.props.isRowNumber) {
          row.unshift(/*#__PURE__*/_react["default"].createElement("td", {
            key: "number_column",
            className: _table["default"].numberColumn
          }, start + index + 1));
        }
        // Is Checkbox?
        if (_this._isShowCheckboxes()) {
          var checked = _this.state.selectedRows.indexOf(key) !== -1;
          var classname = (0, _classnames3["default"])(_table["default"].checkboxColumn, _defineProperty({}, "".concat(_table["default"].checkboxColumnSimple), _this.props.isSimpleCheckboxes));
          row.unshift(/*#__PURE__*/_react["default"].createElement("td", {
            key: "checkbox_column",
            className: classname
          }, /*#__PURE__*/_react["default"].createElement(_disabledMessage["default"], {
            number: _this.props.ajaxLimit,
            disabled: _this._isAjax(),
            placement: "right",
            size: null
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            value: key,
            checked: checked,
            onChange: _this._onSelectRow,
            disabled: _this._isAjax(),
            id: _this.props.name + '_row_' + key
          })))));
        }
        var className = (0, _classnames3["default"])(_defineProperty(_defineProperty({}, _table["default"].selected, _this.state.selectedRows.includes(key)), _table["default"].clickableRow, !_this.state.selectedRows.includes(key) && _this.props.onRowClick && _this.props.showRowClickable), _this.props.setRowClass && _this.props.setRowClass(item));
        return /*#__PURE__*/_react["default"].createElement("tr", {
          key: key,
          className: className
        }, row);
      });
      return rows;
    });
    _defineProperty(_this, "_renderPaginator", function () {
      var total = Math.ceil(_this._getFilteredTotal() / _this.state.perPage);
      if (total <= 1) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdPaginator["default"], {
        total: total,
        currentPage: _this.state.currentPage,
        onPageChange: _this._gotoPage,
        className: _table["default"].paginator
      });
    });
    _defineProperty(_this, "_getFilters", function () {
      // Don't show filter if there is no data
      if (_this._getTotal() === 0) {
        return {};
      }
      if (!(0, _find2["default"])(_this.props.columns, {
        filter: true
      })) {
        return {};
      }
      var filters = {};
      (0, _forEach2["default"])(_this.props.columns, function (column) {
        if ((0, _has2["default"])(column, 'filter') && column.filter === true) {
          var disabled = _this._isAjax() && !column.ajax;
          filters[column.name] = /*#__PURE__*/_react["default"].createElement("div", {
            key: column.name,
            style: {
              marginBottom: '.5em'
            }
          }, /*#__PURE__*/_react["default"].createElement("label", null, column.label), /*#__PURE__*/_react["default"].createElement(_disabledMessage["default"], {
            number: _this.props.ajaxLimit,
            disabled: disabled,
            display: "block",
            placement: "bottom"
          }, /*#__PURE__*/_react["default"].createElement(_filter3["default"], {
            column: column.name,
            value: _this.state.filters[column.name],
            onFilterChange: _this._onFilterChange,
            settings: column.filterSettings,
            disabled: disabled
          })));
        }
      });
      return filters;
    });
    _defineProperty(_this, "_renderListFilters", function () {
      var filters = _this._getFilters();
      if ((0, _isEmpty2["default"])(filters)) {
        return null;
      }
      var result = [];
      (0, _forEach2["default"])(_this.props.columns, function (column) {
        if (filters[column.name]) {
          result.push(filters[column.name]);
        }
      });
      return result;
    });
    _defineProperty(_this, "_renderListSorts", function () {
      var options = [];
      (0, _forEach2["default"])(_this.props.columns, function (column) {
        if (column.sort && (column.ajax || !_this._isAjax())) {
          options.push(/*#__PURE__*/_react["default"].createElement("option", {
            key: 'asc_' + column.name,
            value: 'asc_' + column.name
          }, "Sort by ".concat(column.label, " (A-Z)")));
          options.push(/*#__PURE__*/_react["default"].createElement("option", {
            key: 'desc_' + column.name,
            value: 'desc_' + column.name
          }, "Sort by ".concat(column.label, " (Z-A)")));
        }
      });
      if (options.length === 0) {
        return null;
      }
      var onListSortChange = function onListSortChange(event) {
        var _event$target$value$s = event.target.value.split('_'),
          _event$target$value$s2 = _toArray(_event$target$value$s),
          order = _event$target$value$s2[0],
          other = _event$target$value$s2.slice(1);
        _this._onOrder(other.join('_'), order);
      };
      var value = (_this.state.isAscentOrder ? 'asc' : 'desc') + '_' + _this.state.orderBy;
      return /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-select form-select-sm",
        value: value,
        onChange: onListSortChange
      }, options);
    });
    _defineProperty(_this, "_renderList", function () {
      if (!(0, _isFunction2["default"])(_this.props.renderAsList)) {
        return null;
      }
      var rows = _this._getRowsForPage();
      var start = _this._getStartRowNumber();

      // Render column values
      return rows.map(function (row, index) {
        var key = row[_this.props.rowKey].toString();
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: key
        }, _this.props.renderAsList(row, start + index + 1));
      });
    });
    _defineProperty(_this, "_renderAsList", function () {
      var Template = _this.props.listTemplate;
      var templateProps = {
        tableProps: _this.props,
        perPageOptions: _this._renderPerPageOptions(),
        reloadDataButton: _this._renderReloadDataButton(),
        count: _this._renderCount(_this._getFilteredTotal(), _this._getTotal()),
        list: _this._renderList(),
        paginator: _this._renderPaginator(),
        filterBlock: _this._renderListFilters(),
        filters: _this._getFilters(),
        sortBlock: _this._renderListSorts(),
        rows: _this._getRowsForPage(),
        startNumber: _this._getStartRowNumber() + 1,
        registerFilterFunction: _this._registerFilterFunction
      };
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: _this.state.loading && _this.state.hardLoading
      }, /*#__PURE__*/_react["default"].createElement(Template, templateProps));
    });
    var _settings = _this._getSettings();
    _this.state = {
      data: [],
      total: 0,
      filtered: 0,
      loading: false,
      hardLoading: true,
      currentPage: 1,
      perPage: _settings.perPage,
      selectedRows: (0, _cloneDeep2["default"])(_props.selectedRows),
      selectAllChecked: false,
      filters: _settings.filters,
      orderBy: _settings.orderBy,
      isAscentOrder: _settings.isAscentOrder,
      showOnlySelected: false,
      filterFunction: null
    };
    return _this;
  }
  _inherits(Table, _React$Component);
  return _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.didMount();
      if ((0, _isFunction2["default"])(this.props.rowSelectedCallback)) {
        this.props.rowSelectedCallback(this._getRealSelectedRows());
      }
      if (this._isAjaxMode()) {
        this._update();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // Show warning message
      if (this.props.apiUrl !== '' && this.props.data.length > 0) {
        console.warn('You cannot pass "apiUrl" and "data" props together. "data" will be ignored.');
      }
      this._saveSettings();
      if ((0, _isFunction2["default"])(this.props.rowSelectedCallback)) {
        this.props.rowSelectedCallback(this._getRealSelectedRows());
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.renderAsList) {
        return this._renderAsList();
      }
      var thead = this._renderThead();
      var filter = this._renderFilter();
      var tbody = this._renderTbody();
      var buttons = this._renderButtons();
      var count = this._renderCount(this._getFilteredTotal(), this._getTotal());

      // Calculate the number of columns
      var colSpan = this.props.columns.length;
      if (this.props.isRowNumber) {
        colSpan++;
      }
      if (this._isShowCheckboxes()) {
        colSpan++;
      }
      // Compose the message when there is no filtered data
      var noDataMessage = this.filteredTotal === 0 ? /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        colSpan: colSpan
      }, this.props.noRecordsMessage)) : null;
      var bottomPaginator = null;
      var paginator = this._renderPaginator();
      if (paginator && this.props.showBottomPaginator) {
        bottomPaginator = /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames3["default"])('clearfix', _table["default"].bottomBar)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "float-end"
        }, paginator));
      }
      var showTopBar = buttons || count || paginator;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _table["default"].tableWrapper + ' ' + this.props.wrapperClassName
      }, this.props.showRowActions && /*#__PURE__*/_react["default"].createElement(_actions["default"], {
        wrapperClassName: _table["default"].marginBottom,
        actions: this.props.rowActions,
        selectedRows: this.state.selectedRows,
        afterAction: this._afterAction,
        callbacks: this.props.callbacks,
        disabled: this._isAjax(),
        disabledNumber: this.props.ajaxLimit
      }), showTopBar && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames3["default"])('clearfix', _table["default"].topBar)
      }, buttons, count, /*#__PURE__*/_react["default"].createElement("div", {
        className: "float-end"
      }, paginator)), /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading && this.state.hardLoading
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _table["default"].tableScroll
      }, /*#__PURE__*/_react["default"].createElement("table", {
        className: this.props.className + ' ' + _table["default"].table
      }, /*#__PURE__*/_react["default"].createElement("thead", null, thead, filter), /*#__PURE__*/_react["default"].createElement("tbody", null, tbody, noDataMessage), this._renderTfoot()))), bottomPaginator);
    }
  }]);
}(_react["default"].Component);
_defineProperty(Table, "propTypes", {
  /** The name for the table. It's used when saving the table state. <i>e.g.</i> sortable columns, filters, etc... If there is only one table on the page it's not necessary to assign a name. */
  name: _propTypes["default"].string,
  /** The class name of the wrapper div that contains the table. */
  wrapperClassName: _propTypes["default"].string,
  /** The class name of the table. */
  className: _propTypes["default"].string,
  /** An array with colums. For example:
  <pre>[
  {name: 'id', label: 'ID'},
  {name: 'name', label: 'Name', sort: true, filter: true},
  {name: 'email', label: 'Email', sort: true, filter: true},
  ]</pre> */
  columns: _propTypes["default"].array,
  /** An array of data. For example:
  <pre>[
  {id: 1, name: 'Mike', email: 'mike@gmail.com'},
  {id: 2, name: 'Helen', email: 'helen@gmail.com'},
  {id: 3, name: 'Bob', email: 'bob@gmail.com'},
  ]</pre> */
  data: _propTypes["default"].array,
  /** URL for API <br> Note: You cannot use "apiUrl" and "data" simultaneously; "data" will be ignored.
   */
  apiUrl: _propTypes["default"].string,
  /** A key with a unique value, from "data" above.  This key must exist. */
  rowKey: _propTypes["default"].string,
  /** Show row number or not? */
  isRowNumber: _propTypes["default"].bool,
  /** An array of objects containing JS functions that can be applied to selected rows. <br> <i>E.g.</i> `{name: 'Do something', action: function(selectedRows) {}}` */

  /** An array of functions which can be applied for checked rows. For example:
  <pre>[
  {text: 'Do something', action: function() {}},
  {text: 'Do another thing', action: function() {}},
  ]</pre> */
  rowActions: _propTypes["default"].array,
  /** Show row actions selectbox or not? */
  showRowActions: _propTypes["default"].bool,
  /** An array of rows that will be selected by default */
  selectedRows: _propTypes["default"].array,
  /** A function that will be called afterr changing selected rows */
  rowSelectedCallback: _propTypes["default"].func,
  /** A function that will be called after the table component mounts */
  didMount: _propTypes["default"].func,
  /** Column name that is used for default sorting, if left blank, the first sortable column will be used.  */
  orderBy: _propTypes["default"].string,
  /** Use ascending order or not? */
  isAscentOrder: _propTypes["default"].bool,
  /** Number of rows per page */
  perPage: _propTypes["default"].number,
  /** Show options to change number of rows per page? */
  showPerPageOptions: _propTypes["default"].bool,
  /** Sets the available options for how many rows per page. */
  perPageOptions: _propTypes["default"].array,
  /** Hide "Showing x of y rows" at top of table? */
  hideShowingRowsSummary: _propTypes["default"].bool,
  /** When in AJAX mode, the number of rows that will be returned from an AJAX request. <br> If "0" AJAX will not be used.
   */
  ajaxLimit: _propTypes["default"].number,
  /** When in AJAX mode, this will prevent the page from changing while loading data from an AJAX request */
  isHardLoading: _propTypes["default"].bool,
  /** The regular filter <i>e.g.</i>: <br/>
   <pre>{name: "Bob", email: "@gmail.com"}</pre> */
  filter: _propTypes["default"].object,
  /** A filter that will be applied to the table permanently. <i>e.g.</i>:
  <pre>{isActive: 1}</pre>
  */
  constantFilter: _propTypes["default"].object,
  /** A query that will be appended to all apiURL requests <i>e.g.</i>:
  <pre>{codebook_id: 1}</pre>
  */
  constantQuery: _propTypes["default"].object,
  /** This symbol will mean nothing when put in a filter. */
  emptySymbol: _propTypes["default"].string,
  /** Display a paginator below the table or not? */
  showBottomPaginator: _propTypes["default"].bool,
  /** Show the reload button or not? */
  showReloadButton: _propTypes["default"].bool,
  /** Save the table's state, sort and filter params, in local storage? */
  saveState: _propTypes["default"].bool,
  /** Display the CSV download button or not? */
  isCsvDownload: _propTypes["default"].bool,
  /** Sets the title for the CSV download button. */
  csvButtonTitle: _propTypes["default"].string,
  /** Sets the name of the CSV file to be downloaded */
  csvFilename: _propTypes["default"].string,
  /** Customizable download function */
  csvDownloadFunction: _propTypes["default"].func,
  /** An array of column names, that will be omitted in the CSV file */
  csvOmittedColumns: _propTypes["default"].array,
  /** Display a single, simple checkbox that allows a user to select all or none of the table. */
  isSimpleCheckboxes: _propTypes["default"].bool,
  /** An object with callback functions that can be called when rendering columns and in rowActions. */
  callbacks: _propTypes["default"].object,
  /** The message shown when there are no records. */
  noRecordsMessage: _propTypes["default"].string,
  /** A function that renders the table as a list when called. */
  renderAsList: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
  /** Template component that shows the list. */
  listTemplate: _propTypes["default"].func,
  /** A click event handler for a whole row that accepts row objects */
  onRowClick: _propTypes["default"].func,
  /** If true, and onRowClick is a function, then each row will have a clickable style. */
  showRowClickable: _propTypes["default"].bool,
  /** If this is a function then it will set a className for every row when called. The row can be passed into the function.  */
  setRowClass: _propTypes["default"].func,
  /** Generates a hash based solely on the table name. */
  useOnlyNameForHash: _propTypes["default"].bool,
  /** Information to display in a fixed table footer <i>e.g.</i>:
  <pre>{colNameA: valueA, colNameB: valueB}</pre> */
  footer: _propTypes["default"].object
});
_defineProperty(Table, "defaultProps", {
  name: '',
  wrapperClassName: '',
  className: 'table table-condensed table-striped table-bordered',
  columns: [],
  data: [],
  apiUrl: '',
  rowKey: 'id',
  isRowNumber: false,
  rowActions: [],
  showRowActions: true,
  selectedRows: [],
  rowSelectedCallback: null,
  didMount: function didMount() {},
  orderBy: '',
  isAscentOrder: true,
  perPage: 50,
  showPerPageOptions: true,
  perPageOptions: [10, 25, 50, 100, 200],
  hideShowingRowsSummary: false,
  ajaxLimit: 1000,
  isHardLoading: true,
  filter: {},
  constantFilter: {},
  constantQuery: {},
  emptySymbol: '*',
  showBottomPaginator: true,
  showReloadButton: true,
  saveState: true,
  isCsvDownload: false,
  csvButtonTitle: 'CSV',
  csvFilename: 'download.csv',
  csvDownloadFunction: null,
  csvOmittedColumns: [],
  isSimpleCheckboxes: false,
  callbacks: {},
  noRecordsMessage: 'No matching records found',
  renderAsList: null,
  listTemplate: _listTemplate["default"],
  onRowClick: null,
  showRowClickable: true,
  setRowClass: null,
  useOnlyNameForHash: false,
  footer: null
});